import React from 'react'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'
import createMarkup from '../../../helpers/createMarkup'

function Preview ({contents, openEditor, loading, contentType}) {
  const keys = {
    passage: 'passage',
    question: 'question',
    teacherGuidance: 'teacher guidance',
    content: 'content',
    instructions: 'instructions',
    audioTranscript: 'audio transcript',
    videoTranscript: 'video transcript',
    imageDescription: 'image description',
  }
  const view = contents || `<p>Add ${keys[contentType]} here...</p>`
  
  return (
    <div>
      {!loading && 
        <div 
          dangerouslySetInnerHTML={createMarkup(view)}
          onClick={openEditor}
        />
      }
      <BeatLoader loading={loading} />
    </div>
  )
}

Preview.propTypes = {
  contents: PropTypes.string,
  openEditor: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

Preview.defaultProps = {
  contents: ''
}

export default Preview


// WEBPACK FOOTER //
// ./src/components/Content/ManageContentComponents/Preview.js